import { useEffect } from "react";
import { Route, Routes } from "react-router";

import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import { logDailyHomepageVisit } from "./lib/analytics";
import PDFMergeTool from "./components/PDFMergeTool";
import PDFOrganizer from "./components/PDFOrganizer";
import PDFToJPGConverter from "./components/PDFConverter";

function App() {
	useEffect(() => {
		// Only logs once per Nigeria day (client guard + backend unique)
		logDailyHomepageVisit().catch(console.error);

		// eslint-disable-next-line
	}, []);

	return (
		<>
			<Navbar />
			<Routes>
				<Route path="/" element={<Home />} />

				<Route path="/pdf-merge" element={<PDFMergeTool />} />
				<Route path="/pdf-organize" element={<PDFOrganizer />} />
				<Route path="/pdf-convert" element={<PDFToJPGConverter />} />
			</Routes>
		</>
	);
}

export default App;
